import { StaticSiteDetailsFallback } from '@/routes/static-site/tabs/overview/sections/details/fallback'
import { StaticSiteRecentDeploymentsFallback } from '@/routes/static-site/tabs/overview/sections/latest-deployments/fallback'

export const OverviewTabFallback = () => {
  return (
    <div className="space-y-6 pb-25">
      <StaticSiteDetailsFallback />
      <StaticSiteRecentDeploymentsFallback />
    </div>
  )
}
